<template>
  <div :class="{splicingTable: destination}" class="splicing-tables" :id="object.cb_id">
    <table-data-object
        :object-name="getCableIdentification()"
        :is-selected="isCableSelected()"
        :disabled="disabled"
        :side="side"
        @click="selectCable"
        @open-menu-object="openCableMenu"
      />
      
    <table>
      <component
        v-for="(fiber, index) in object.fibers"
        :key="fiber.fb_id"
        :update-counter="updateCounter"
        :is="rowComponent"
        :fiber-per-tube-cache="fibersPerTube"
        :index="index+1"
        :number-in-cable="fiber.fb_nr_in_cable"
        :tube="fiber.fb_nr_tube"
        object-type="cable"
        :object-name="getCableIdentification(index)"
        :tube-number="getTubeIdentification(fiber)"
        :connection-point-name="'F ' + fiber.fb_nr_in_tube"
        :state="getConnectionPointState(fiber, 'fb')"
        :tube-color="getFiberColor(fiber.fb_nr_tube)"
        :connection-point-color="getFiberColor(fiber.fb_nr_in_tube)"
        :tube-is-selected="isTubeSelected(fiber)"
        :connection-point-is-selected="isFiberSelected(fiber)"
        :disabled="disabled"
        :connection-type="getConnectionType(fiber.fb_id)"
        @select-tube="selectTube(fiber)"
        @select-connection-point="selectFiber(fiber,index)"
        @open-menu-tube="openTubeMenu($event, fiber)"
        @open-menu-connection-point="openConnectionPointMenu($event, fiber, 'fb')"
      />
    </table>
  </div>
</template>

<script>
import TableDataObject from "@/components/Home/Forms/_SpecialTabs/Splicing/ObjectTable/TableDataObject";
import TableDataTube from "@/components/Home/Forms/_SpecialTabs/Splicing/ObjectTable/TableDataTube";
import { listsMixin } from "@/mixins/listsMixin";
import { splicingObjectItemsListMixin } from "@/mixins/splicingObjectItemsListMixin";
import _ from "lodash";

export default {
  name: "ClosureFormSplicingTabCableFibers",
  components: {
    TableDataObject,
    TableDataTube
  },
  mixins: [splicingObjectItemsListMixin, listsMixin],
  props:{
    destination: {
      type: Boolean,
      default: false
    },
    fibersPerTube: {
      type: Object
    }
  },
  data() {
    return {
      fiberColors: null,
    };
  },
  mounted(){
    this.loadFiberColors();
  },
  methods: {
    async loadFiberColors() {
      this.fiberColors = await this.getList("list_fo_color", [], true);
    },
    getFiberColor(nr) {
      let colorNr = nr % 12;
      if (colorNr === 0) {
        colorNr = 12;
      }

      if (this.fiberColors) {
        let color = this.fiberColors.find(item => item.code == colorNr);
        if (
          color &&
          color.libelle.length === 7 &&
          color.libelle.startsWith("#")
        ) {
          return color.libelle;
        }
      }
      switch (colorNr) {
        case 1:
          return "#C10D23";
        case 2:
          return "#0C0C7C";
        case 3:
          return "#0B810B";
        case 4:
          return "#E8BC3E";
        case 5:
          return "#650C65";
        case 6:
          return "#FFFFFF";
        case 7:
          return "#D68027";
        case 8:
          return "#979797";
        case 9:
          return "#993300";
        case 10:
          return "#1D2124";
        case 11:
          return "#75B6C6";
        case 12:
          return "#D24590";
      }
    },

    getCableIdentification() {
      return this.object.cb_label ? this.object.cb_label : `Cb: ${this.object.cb_id}`;
    },
    getTubeIdentification(fiber) {
      let identification = null;
      let tubeNumber = fiber.fb_nr_tube;

      if (fiber.fb_nr_in_tube === 1) {
        identification = "T " + tubeNumber;
      }

      return identification;
    },

    isCableSelected() {
      return (
        this.selectedItem &&
        this.selectedItem.type === "cable" &&
        this.selectedItem.cb_uuid === this.object.cb_uuid
      );
    },

    isTubeSelected(fiber) {
      return (
        this.selectedItem &&
        this.selectedItem.type === "tube" &&
        this.selectedItem.cable_uuid === this.object.cb_uuid &&
        this.selectedItem.tube_id === fiber.fb_nr_tube
      );
    },

    isFiberSelected(fiber) {
      return (
        this.selectedItem &&
        this.selectedItem.type === "fiber" &&
        this.selectedItem.fb_uuid === fiber.fb_uuid
      );
    },

    selectCable() {
      let cable = _.cloneDeep(this.object);
      cable.type = "cable";
      this.selectItem(cable);
    },

    selectTube(selectedFiber) {
      let tubeID = selectedFiber.fb_nr_tube;
      let tube = {
        type: "tube",
        cable_uuid: this.object.cb_uuid,
        tube_id: tubeID
      };
      tube.fibers = this.object.fibers.filter(
        fiber => fiber.fb_nr_tube === tubeID
      );
      this.selectItem(tube);
    },

    selectFiber(selectedFiber) {
      let fiber = _.cloneDeep(selectedFiber);
      fiber.type = "fiber";
      this.selectItem(fiber);
    },

    openCableMenu(e) {
      let connectionPoints = this.object.fibers;
      this.openMenu({ event: e, connectionPoints });
    },

    openTubeMenu(e, selectedFiber) {
      let connectionPoints = this.object.fibers.filter(
        fiber => fiber.fb_nr_tube === selectedFiber.fb_nr_tube
      );
      this.openMenu({ event: e, connectionPoints });
    },
    getConnectionType(id){
      let type = '';
      if(this.connections){
        const originConnection = this.connections.find(connection => connection.origin.id === id);
        if(originConnection){
          type = originConnection.mode;
        }else{
          const destinationConnection = this.connections.find(connection => connection.destination.id === id);
          if(destinationConnection){
            type = destinationConnection.mode;
          }
        }
      }
      return type;
    }
  }
};
</script>
<style scoped>
.splicingTable{
  padding: 0px 10px;
  background-color: white;
  border-radius: 10px;
}
.splicing-tables table div{
  height: 25px;
}
.splicingTable table div {
  margin-bottom: 5px;
  display: flex;
  justify-content: flex-start;
}
.splicingTable table div:only-child, .splicing-tables table div:only-child{
  margin-bottom: 0px;
}
.splicingTable table div:last-child, .splicing-tables table div:last-child{
  margin-bottom: 0px !important;
}
.splicing-tables{
  padding: 4.9px 10px;
  background-color: white;
  border: 1px solid rgb(147, 144, 144);
  border-radius: 10px;
  margin-bottom: 5px !important;
}
</style>



// WEBPACK FOOTER //
// src/components/Home/Forms/_SpecialTabs/Splicing/CableFibers.vue